import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import cyan from '@material-ui/core/colors/cyan';

class AudioSelector extends React.Component {
  state = {
    open: false,
    anchorEl: null,
  };
  handleClick = (e) => {
    e.preventDefault();
    this.props.onOverlayFixed(true);
    this.props.onOpenMenu(true);
    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };
  handleClose = (e) => {
    this.setState({
      open: false,
      anchorEl: null
    });
    this.props.onOverlayFixed(false);
    this.props.onOpenMenu(false);
  };
  handleChange = (event, index, value) => {
    this.setState({value});
  }
  render = () => {
    const overlay = this.props.overlay;
    const audioTracks = this.props.audioTracks;
    if (!overlay || audioTracks === undefined || audioTracks.length === 0) {
      return (<div/>);
    }
    const { anchorEl } = this.state;
    const currentAudioTrack = this.props.currentAudioTrack;
    const self = this;
    const menuItems = audioTracks.map((audioTrack, i) => {
      var style = {};
      if (audioTrack !== undefined && currentAudioTrack === audioTrack.id) {
        style['backgroundColor'] = cyan[400];
      }
      const key = 'audio-track' +i;
      return (<MenuItem
          key={key}
          value={i}
          style={style}
          onClick={evt => self.props.onSelectAudioTrack(audioTrack)}
        >{audioTrack.name}</MenuItem>)
    });

    return (
      <div
        id="audio-selector"
      >
        <Button
          variant="text"
          aria-owns={anchorEl ? 'audio-menu' : undefined}
          aria-haspopup="true"
          style={{color: 'white', minWidth: '36px', backgroundColor:'rgba(0, 0, 0, 0.6)'}}
          onClick={this.handleClick}
        >
          音声
        </Button>
        <Menu
          id="audio-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {menuItems}
        </Menu>
      </div>
    );
  }
};
export default AudioSelector;



// WEBPACK FOOTER //
// ./src/components/AudioSelector.js